import { SUBSPLASH_PHONE_AUTH_PROVIDER_ID } from '@omni/kit/constants/identifiers';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import React from 'react';
import { View } from 'react-native';

import KitButton from '../components/KitButton';
import { AuthProvider, AuthService } from './index';

export const LoginButtons = ({
  appKey,
  customReturnUrl,
  loginEnabledProviders,
  openInNewTab,
  source,
  targetProvider,
}: {
  appKey: string;
  customReturnUrl?: string;
  loginEnabledProviders: AuthProvider[];
  openInNewTab?: boolean;
  source?: string;
  targetProvider?: AuthProvider;
}): JSX.Element => {
  const { t } = useTranslation(['common']);

  if (loginEnabledProviders.length === 1) {
    const provider = loginEnabledProviders[0];

    return (
      <View key={provider.authproviderid} style={{ marginBottom: Spacing.m }}>
        <KitButton
          titleStyle={{ marginLeft: 10 }}
          onPress={() => {
            AuthService.authenticate({
              appKey,
              provider,
              targetProvider,
              customReturnUrl,
              source,
              openInNewTab,
            });
          }}
          title={t('common:buttonTitleLogInOrSignUp')}
          color={Colors.N900}
          secondary={false}
        />
      </View>
    );
  }

  return (
    <>
      {loginEnabledProviders
        .filter(
          (provider) =>
            provider.authproviderid !== SUBSPLASH_PHONE_AUTH_PROVIDER_ID
        )
        .map((provider) => (
          <View
            key={provider.authproviderid}
            style={{ marginBottom: Spacing.m }}
          >
            <KitButton
              icon={provider.icon}
              titleStyle={{ marginLeft: 10 }}
              onPress={() => {
                AuthService.authenticate({
                  appKey,
                  provider,
                  targetProvider,
                  customReturnUrl,
                  source,
                  openInNewTab,
                });
              }}
              title={`Continue with ${provider.title}`}
              secondary
            />
          </View>
        ))}
    </>
  );
};
